import {getJson, postJson, patchJson} from '@/util/ajaxUtils';

export const getRoutinePushes = (appId, params = {}) =>
    getJson(`/app/${appId}/hr/push/routine`, {params});

export const createRoutinePush = (appId, data) => postJson(`/app/${appId}/hr/push/routine`, {data});

export const updateRoutinePush = (appId, id, data) =>
    patchJson(`/app/${appId}/hr/push/routine/${id}`, {data});

export const getSpecificPushes = (appId, params = {}) =>
    getJson(`/app/${appId}/hr/push/specific`, {params});

export const getSpecificPushDetail = (appId, taskId, params = {}) =>
    getJson(`/app/${appId}/hr/push/specific/${taskId}`, {params});

export const createSpecificPush = (appId, data) =>
    postJson(`/app/${appId}/hr/push/specific`, {data});

export const validateRoster = (appId, taskType, file) => {
    const data = new FormData();
    data.append('taskType', taskType);
    data.append('file', file);
    return postJson(`/app/${appId}/hr/push/roster/validate`, {
        data,
        headers: {'Content-Type': 'multipart/form-data'},
        custom: {showErrorNotification: false, throwError: true},
    });
};

export const downloadRosterTemplate = async (appId, taskType) => {
    const response = await getJson(`/app/${appId}/hr/push/roster/template/${taskType}`, {
        responseType: 'blob',
        custom: {rawResponse: true},
    });
    return response.data;
};

export const getPushHistory = (appId, taskId, params = {}) =>
    getJson(`/app/${appId}/hr/push/${taskId}/history`, {params});

export const exportPushHistory = async (appId, taskId, params = {}) => {
    const response = await getJson(`/app/${appId}/hr/push/${taskId}/history/export`, {
        params,
        responseType: 'blob',
        custom: {rawResponse: true},
    });
    return response.data;
};

export const getPushHistoryDetail = (appId, historyId, params = {}) =>
    getJson(`/app/${appId}/hr/push/history/${historyId}`, {params});

export const getPushBatchLogs = (appId, params = {}) =>
    getJson(`/app/${appId}/hr/push/logs/batches`, {params});

export const getPushUserLogs = (appId, params = {}) =>
    getJson(`/app/${appId}/hr/push/logs/users`, {params});

export const retryPush = (appId, historyId, targetId) =>
    postJson(`/app/${appId}/hr/push/history/${historyId}/retry`, {params: {targetId}});

export const executePushOnce = (appId, taskId) =>
    postJson(`/app/${appId}/hr/push/${taskId}/execute-once`);

export const getApprovals = (appId, params = {}) => getJson(`/app/${appId}/hr/approval`, {params});

export const getApprovalDetail = (appId, taskId) => getJson(`/app/${appId}/hr/approval/${taskId}`);

export const approvePush = (appId, taskId, opinion) =>
    postJson(`/app/${appId}/hr/approval/${taskId}/approve`, {params: {opinion}});

export const rejectPush = (appId, taskId, opinion) =>
    postJson(`/app/${appId}/hr/approval/${taskId}/reject`, {params: {opinion}});
